import { IListItem } from '../../list-page/interfaces/interfaces';
import ProductPriceFormat from '../product-price/product-price-format';
import ProductClock from '../product-clock/product-clock';
import DiscountBadge from '../../../ui/discount-badge/discount-badge';

interface IProductPricesProps {
    product: IListItem,
    isGoogleShoppingFeed?: boolean,
    isFirstRowHidden?: boolean,
    isSecondRowHidden?: boolean,
    isThirdRowHidden?: boolean,
    isDiscountBadgeHidden?: boolean,
    isClockHidden?: boolean,
}

/**
 * Product prices general widget.
 */
const ProductListPrices = (props: IProductPricesProps) => {

    const product = props.product;
    const withCouponEnabled = product.couponCampaignID > 0;
    const isFreeForWCA = product.freeForWCA || false;
    const isWithCoupon = withCouponEnabled && !props.isGoogleShoppingFeed && product.couponPrice > 0;
    const isSamePrice = product.msrp === product.skuPrice;

    return (
        <div className="flex flex-col">
            <div className="flex-1">
                {/* prices row #1: different prices / with coupon - props.isFirstRowHidden*/}
                {
                    props.isFirstRowHidden !== true && (product.couponPrice > 0 || !isSamePrice) &&
                    <div className="flex items-center">

                        {/* MSRP price */}
                        <div className="text-base text-gray-500 mr-2">
                            <s aria-hidden="true"><ProductPriceFormat price={ product.msrp } accessible={ false } /></s>
                            <span className="sr-only">Full Price ${ product.msrp }</span>
                        </div>

                        {/* on sale: sku price if 'with coupon' price exists */}
                        {
                            (product.couponPrice > 0 && !isSamePrice) &&
                            <div className="text-sm text-gray-500">
                                On Sale <span><ProductPriceFormat price={product.skuPrice} /></span>
                            </div>
                        }
                    </div>
                }

                {/* prices row #1: same price */}
                {
                    props.isFirstRowHidden !== true && isSamePrice && product.couponPrice <= 0 &&
                    <div className="flex items-center text-base text-gray-500">Now</div>
                }

                {/* prices row #2 */}
                <div className="flex items-center">

                    {/* main price: if 'with coupon' exists -> 'with coupon' price, otherwise sku price */}
                    {
                        props.isSecondRowHidden !== true && <div className="text-xl font-bold text-gray-700">
                        {
                            isWithCoupon &&
                            <span>
                            <ProductPriceFormat price={product.couponPrice}/>&nbsp;

                                <span className="sr-only">
                                With Coupon: <span>{product.couponCode}</span>
                            </span>
                        </span>
                        }

                            {!isWithCoupon && isFreeForWCA &&
                                <span><ProductPriceFormat price={product.skuPrice}/>
                                    <span className="text-base font-normal"> or</span><span className="text-base font-bold"> FREE with </span>
                                    <span><a className="text-base font-bold" href="/subscriptions">Waves Creative Access</a></span>
                                </span>}

                        {!isWithCoupon && !isFreeForWCA && <ProductPriceFormat price={product.skuPrice}/>}

                    </div>
                    }

                    {/* discount red tag */}
                    {
                        props.isDiscountBadgeHidden !== true && product.discount > 0 &&
                        <DiscountBadge discount={product.discount} />
                    }
                </div>

                {/* prices row #3 */}
                {
                    props.isThirdRowHidden !== true && product.couponCode &&
                    <div className="flex items-center">
                        <div className="text-base text-gray-700 font-bold" aria-hidden={ true }>With Coupon: <span className="text-red">{ product.couponCode }</span></div>
                    </div>
                }
            </div>

            {
                props.isClockHidden !== true && product.saleEndDate &&
                <div className="mt-4 flex">
                    <ProductClock saleEndDate={ new Date(product.saleEndDate) } showSeconds={false} prefixText="Sale Ends in" clockSeparator='style-h-m-s' />
                </div>
            }
        </div>
    )
};

export default ProductListPrices;